var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shooting-star",on:{"click":function($event){return _vm.clicked(_vm.sign)}}},[_c('img',{staticClass:"tail",attrs:{"src":require("@/assets/img/games/munster/shooting_star.png")}}),_c('img',{staticClass:"birth-sign",attrs:{"src":require(`@/assets/img/games/munster/${_vm.sign}.svg`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }